<template>
    <el-container style="height: 100%">
        <el-header style="height: 30px">
            <van-nav-bar title="未赠送信息" left-text="返回" left-arrow @click-left="historyBackPath('intebotab')"/>
        </el-header>
        <el-main style="height: 100%">
            <el-form :inline="true" :model="searchParms" size="mini">
                <el-form-item label="品牌门店">
                    <el-cascader :options="storeData" filterable clearable v-model="searchParms.storeStructs" :props="{ checkStrictly: true }" size="mini" style="width: 100%" @change="storeChange"></el-cascader>
                </el-form-item>
            </el-form>
            <el-table height="calc(100% - 4rem)" border :data="inteboNotDePositData" size="mini" style="text-align: center" highlight-current-row>
                <el-table-column label="门店"  align="center" prop="storename">
                    <template slot-scope="scope">
                        {{scope.row.parentname}}/{{scope.row.storename}}
                    </template>
                </el-table-column>
                <el-table-column label="赠送内容"  align="center" prop="sendcontent"></el-table-column>
                <el-table-column label="操作"  align="center" width="100" fixed="right">
                    <template slot-scope="scope">
                        <el-button @click="updateInteboDeposit(scope)" :loading="queryLoadBtton" type="text" size="small">确定赠送</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            queryLoadBtton:false,
            curIndex:0,
            inteboSend:{
                parentname:"",
                storename:"",
                sysbillid:"",
                sendcontent: ""
            },
            dialogVisible:false,
            storeData:[],
            inteboNotDePositData:[],
            searchParms:{
                parentid:"",
                storeid:"",
            },
        }
    },
    created() {
        this.getInteboStoreStructs();
        this.getInteboSendByFinished();
    },
    methods:{
        updateInteboDeposit(scope){
            this.$dialog.confirm({
                title: '赠送',
                message: "你确定已经赠送了吗？",
            }).then(() => {
                this.queryLoadBtton=true;
                this.$post("intebosale/updateInteboSendFinished",{id:scope.row.id,finished:1}).then(res=>{
                    if(res.sucess) {
                        this.getInteboSendByFinished();
                        this.$message({message: "保存成功", type: 'success'});
                        this.dialogVisible = false;
                        this.queryLoadBtton = false;
                    }
                });
            });

        },
        openPay(scope){
            this.dialogVisible=true;
            this.curIndex=scope.$index;
            this.inteboDePostit=scope.row;
        },
        storeChange(val){
            this.searchParms.parentid="";
            this.searchParms.storeid="";
            if(val[1]){
                this.searchParms.parentid=val[0];
                this.searchParms.storeid=val[1];
            }
            else{
                if(val[0]){
                    this.searchParms.parentid=val[0];
                }
            }
            this.getInteboSendByFinished();
        },
        getInteboSendByFinished(){
            this.$post("intebosale/getInteboSendByFinished",{parentid: this.searchParms.parentid,storeid:this.searchParms.storeid}).then(res=>{
                this.inteboNotDePositData=res.object;
            });
        },
        getInteboStoreStructs(){
            this.$post("inteboStore/getInteboStoreStructs").then(res=>{
                if(res.sucess){
                    this.storeData=res.object;
                }
            });
        }
    }
}
</script>
<style lang="scss" rel="stylesheet/scss">
.notpay .el-input-number .el-input__inner {
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/page/intebo/intebotab/notsend.vue